export const SCREENS = {
    m: '320px',
    // => @media (min-width: 360px) { ... }
  
    t: '768px',
    // => @media (min-width: 768px) { ... }
  
    d: '1024px',
    // => @media (min-width: 1024px) { ... }
  
    ld: '1366px',
    // => @media (min-width: 1366px) { ... }
  };
  
  export const SPACING = {
    0: '0',
    1: '0.0625rem',
    2: '0.125rem',
    4: '0.25rem',
    6: '0.375rem',
    8: '.5rem',
    12: '.75rem',
    16: '1rem',
    20: '1.25rem',
    24: '1.5rem',
    32: '2rem',
    40: '2.5rem',
    48: '3rem',
    64: '4rem',
    80: '5rem',
    96: '6rem',
    100: '6.25rem',
    128: '8rem',
    160: '10rem',
    200: '12.5rem',
    256: '16rem',
    300: '18.75rem',
    320: '20rem',
    400: '25rem',
    500: '31.25rem',
    512: '32rem',
    600: '37.5rem',
    700: '43.75rem',
    800: '50rem',
    1000: '62.5rem',
    '1/4': '25%',
    '1/2': '50%',
    '3/4': '75%',
    full: '100%',
    fit: 'fit-content',
    max: 'max-content',
  };
  
  export const ANIMATION = {
    bounce: 'bounce .4s linear forwards .2s',
    'circular-progress': 'circular-progress 850ms linear 1ms infinite',
    fadeInUp: 'fade-in-up 0.2s ease-out',
    shimmer: 'shimmer 1.5s infinite',
  };
  
  export const KEYFRAMES = {
    bounce: {
      '50%': { transform: 'scale(1.2)' },
      '75%': { transform: 'scale(.9)' },
      '100%': { transform: 'scale(1)' },
    },
    'circular-progress': {
      '0%': {
        'stroke-dasharray': '5.6px 120px',
        'stroke-dashoffset': '0',
      },
      '12.5%, 12.61%': {
        'stroke-dasharray': '42px 120px',
        'stroke-dashoffset': '0',
      },
      '50%, 50.11%': {
        'stroke-dasharray': '42px 120px',
        'stroke-dashoffset': '-52px',
      },
      '100%': {
        'stroke-dasharray': '5.6px 120px',
        'stroke-dashoffset': '-126px',
      },
    },
    'fade-in-up': {
      '0%': {
        opacity: 0,
        transform: 'translateY(8px)',
      },
      '100%': {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
    shimmer: {
      '100%': {
        transform: 'translateX(100%)',
      },
    },
  };
  
  export const COLORS = {
    current: 'currentColor',
    transparent: 'transparent',
    white: '#FFFFFF',
    primary: {
      10: 'var(--theme-primary-10)',
      40: 'var(--theme-primary-40)',
      50: 'var(--theme-primary-50)',
      100: 'var(--theme-primary-100)',
      400: 'var(--theme-primary-400)',
      500: 'var(--theme-primary-500)',
      700: 'var(--theme-primary-700)',
      800: 'var(--theme-primary-800)',
      900: 'var(--theme-primary-900)',
    },
    green: {
      10: '#f7fcfc',
      40: '#E3EFEC',
      50: '#e7f3f1',
      100: '#b5dad3',
      400: '#41a18d',
      500: '#118970',
      700: '#0c6150',
      800: '#094b3e',
      900: '#0E342C',
    },
    blue: {
      10: '#f7f9fc',
      50: '#e8edf7',
      100: '#b7c8e5',
      400: '#4572bd',
      500: '#164fac',
      700: '#10387a',
      800: '#0c2b5f',
    },
    yellow: {
      10: '#FCFCF7',
      50: '#fbf8ea',
      100: '#f4e8bd',
      400: '#e2c354',
      500: '#dbb429',
      700: '#9b801d',
      800: '#786317',
    },
    red: {
      10: '#fcf7f7',
      50: '#f7e8e8',
      100: '#e5b7b7',
      400: '#bd4545',
      500: '#ac1616',
      700: '#7a1010',
      800: '#5f0c0c',
    },
    violet: {
      10: '#faf7fc',
      50: '#f1e8f7',
      100: '#d3b7e5',
      400: '#8d45bd',
      500: '#7016ac',
      700: '#50107a',
      800: '#3e0c5f',
    },
    seablue: {
      10: '#f7fcfc',
      50: '#e9f6f9',
      100: '#bce3eb',
      400: '#52b7cb',
      500: '#27a5be',
      700: '#1c7587',
      800: '#155b69',
    },
    gray: {
      0: '#ffffff',
      10: '#fafafa',
      20: '#f5f5f5',
      40: '#e0e0e0',
      60: '#b4b4b4',
      80: '#999999',
      100: '#7c7c7c',
      300: '#5f5f5f',
      500: '#454545',
      700: '#282828',
      900: '#141416',
      1000: '#DBE1E2',
    },
    'green-gray': {
      40: '#e3efec',
      60: '#cbd7d5',
      100: '#a4b0ad',
      300: '#717d7b',
      500: '#404c49',
      800: '#0d1917',
    },
  };
  